import { PropType, defineComponent, ref, watch, Ref } from 'vue'
import { host } from '@/const'
import axios from '@/axios'
import PersonalDataModal from '@//components/personal-data-modal'
import './style.sass'

export default defineComponent({
  props: {
    personalData: {
      type: Object as PropType<Ref<boolean | undefined>>,
      required: true,
    },
    personalError: {
      type: Object as PropType<Ref<string | undefined>>,
      required: true,
    }
  },
  setup(props) {
    const agreementOpen = ref(false)
    const agreement = ref(undefined)
    return () => (
      <div class="checkbox-block">
        <label>
          <input
            checked
            type="checkbox"
            name='personal_data'
            v-model={props.personalData.value}
          />
          <div class="checkbox"/>
          <span class="checkbox-text">
            <span onClick={async (e) => {
              e.preventDefault();
              if (agreement.value === undefined) {
                agreement.value = (await axios.get(`https://backend.cable.ru/api/v1/personal-data-agreement`))?.data.items[0]
              }
              agreementOpen.value = true
            }} class="link-agreement">Cогласие</span>
            {' '}
            на обработку персональных данных</span>
        </label>
        {props.personalError.value
          ? (<span class="error-message">{props.personalError.value}</span>)
          : null
        }
        {agreementOpen.value
          ? (<PersonalDataModal
            agreement={agreement.value}
            agreementOpen={(value: any) => agreementOpen.value = value}
          />)
          : null
        }
      </div>
    )
  }
})